import { Injectable } from '@angular/core';
import { Platform, Events } from 'ionic-angular';

/*
  Generated class for the MenuProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MenuProvider {

  pages: any = [];
  favorite: any = [];
  pageBuilder: any = [];
  public newHome: boolean = true;
  constructor(
    public platform: Platform,
    public events: Events
  ) {

    events.subscribe('user:pagebuilder', (menu) => {
      this.pageBuilder = menu;
      this.pageBuilder.forEach(element => {
        element.items.forEach(elements => {
          if(!elements.iconUrl.includes(".svg")){
            elements.iconUrl = 'assets/icon_new/icon_custom-page.svg'
          }
        });
      });
      events.publish('user:pagebuilderGD', menu);
    })

    events.subscribe('user:favmenu', (favMenu) => {
      this.favorite = favMenu;
    })
  }

}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/menu/menu.ts